/*
 * @Description: 
 * @Date: 2025-06-23 14:28:46
 * @LastEditors: function
 * @LastEditTime: 2025-07-11 14:55:31
 * @FilePath: \protal-web\src\api\home\index.js
 */
import request from '@/utils/request.js'


// banner图等
export function getHome() {
  return request({
    url: `/dj-portal-api/public/home`,
    method: "get",
  });
}
// banner图等
export function getUserInfo() {
  return request({
    url: `/auth-api/user/v1/getUserInfo`,
    method: "get",
  });
}

//货源
export function getCargo(data) {
  return request({
    url: `/dj-portal-api/cargo-sources/public/page`,
    method: "post",
    data
  });
}

//车源
export function getVehicle(data) {
  return request({
    url: `/dj-portal-api/vehicle-sources/public/page`,
    method: "post",
    data
  });
}

export function getNewsInfo(data) {
  return request({
    url: `/dj-portal-api/public/news-info`,
    method: "get",
    params: data
  });
}

// 外部链接
export function getLinks() {
  return request({
    url: `/dj-portal-api/public/external-links`,
    method: "get"
  });
}

// 根据接口加密状态
export function getApiStatus(data) {
  return request({
    url: `/dj-common-api/cipher/v1/status`,
    method: 'get',
    params: data
  })
}